/**
 * Canopy cart drawer behavior (additions to Horizon's cart drawer):
 * - Closes when the shopper clicks outside the drawer on wide viewports. Below 990px Horizon
 *   opens the drawer as a modal with a backdrop and already closes it on backdrop click.
 * - Closes shortly after the last item is removed, once the empty-cart state has been seen.
 * Auto-open on add is Horizon's own `auto_open_cart_drawer` theme setting.
 */
const EMPTY_CART_CLOSE_DELAY = 1500;

/** Elements whose clicks should not dismiss the drawer. */
const KEEP_OPEN_SELECTOR = [
  '[aria-controls="cart-drawer"]', // header cart toggle handles its own open/close
  'dialog[open]', // quick-add and other dialogs layered over the page
  'add-to-cart-component',
  'button[name="add"]',
  '.sticky-add-to-cart',
].join(',');

/** @type {ReturnType<typeof setTimeout> | undefined} */
let emptyCartTimer;

function getDrawer() {
  return /** @type {(HTMLElement & { isOpen?: boolean, close?: () => void }) | null} */ (
    document.getElementById('cart-drawer')
  );
}

document.addEventListener(
  'pointerdown',
  (event) => {
    const drawer = getDrawer();
    if (!drawer?.isOpen) return;

    const panel = drawer.querySelector('dialog');
    // Modal (narrow viewport) mode already closes on backdrop click.
    if (!panel || panel.matches(':modal')) return;

    const target = event.target;
    if (!(target instanceof Element)) return;
    if (panel.contains(target) || target.closest(KEEP_OPEN_SELECTOR)) return;

    drawer.close?.();
  },
  true
);

document.addEventListener('shopify:cart:lines-update', (event) => {
  clearTimeout(emptyCartTimer);

  const { promise } = /** @type {{ promise?: Promise<{ cart?: { totalQuantity?: number } | null }> }} */ (
    /** @type {unknown} */ (event)
  );

  promise
    ?.then((result) => {
      if (result?.cart?.totalQuantity !== 0) return;

      emptyCartTimer = setTimeout(() => {
        const drawer = getDrawer();
        if (drawer?.isOpen) drawer.close?.();
      }, EMPTY_CART_CLOSE_DELAY);
    })
    .catch(() => {});
});
